import React, { Component } from 'react'

class SearchStoreLocation extends Component {
    render() {
        return (
            <div>
                {this.props.items.length ? (
                    <table className="display_table">
                        <thead>
                            <tr className="table-header">
                                <th></th>
                                <th>Title</th>
                                <th>Address</th>
                                <th>City</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.props.items.map((item, i) =>
                                <tr className="clickable" key={i} onClick={() => this.props.history.push(this.props.basePath + '/' + item.permalink)}>
                                    <td className="record-number">{i + this.props.startPosition + 1}</td>
                                    <td data-id="Title">{ item.title }</td>
                                    <td data-id="Address">{ item.address }</td>
                                    <td data-id="City">{ item.city }</td>
                                    <td className="edit-cell"><div className="edit_btn">View</div></td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                ) : (
                    <div>No Results</div>
                )}
            </div>
        )
    }
}

SearchStoreLocation.defaultProps = {
    items: [],
    startPosition: 0,
    clickHandle: null
}

export default SearchStoreLocation



// WEBPACK FOOTER //
// ./src/components/search/SearchStoreLocation.js